import React, { useState, useEffect } from "react";
import axios from "axios";
import TextInput from "components/Input/TextInput.js";
import {
   IntInput
} from "components/Input/Index.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import { putLinkedCalendar, postLinkedCalendar } from "services/ConfigServices";
import styled from "styled-components";
import { linkedcalendartext } from "variables/MBM/schedule";


const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

function LinkedCalendarDialog(props) {
  const memv2versionactive = localStorage.getItem('memv2version') || 0;
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mbm_geb_control_schedules = permis.includes("mbm_geb_control_schedules");
  const { closeModal, refetch, setLoading, setNotification, currentCalendar } = props;
  const [name, setName] = useState(currentCalendar?.parameters?.name || "");
  const [url, setUrl] = useState(currentCalendar?.parameters?.url || "");
  const [refreshtime, setRefreshtime] = useState(currentCalendar?.parameters?.refreshtime || "");
  const [groups, setGroups] = useState(currentCalendar?.groupid ? "" + currentCalendar.groupid : "");
  const [buttonDisabled, setButtonDisabled] = useState(true);


  const handleNameChange = (event) => { setName(event.target.value); };
  const handleUrlChange = (event) => { setUrl(event.target.value); };
  const handleRefreshtimeChange = (event) => { setRefreshtime(event.target.value); };

  const classes = useStyles();

  const handleSubmit = (event) => {
    if (currentCalendar)
      updateLinkedCalendar(event);
    else
      createLinkedCalendar(event);
    //setLoading(true);
    closeModal();
  };

  useEffect(() => {
    if (!name || !groups || !url || !refreshtime || groups.length === 0)
      setButtonDisabled(true);
    else
      setButtonDisabled(false);
  },[name,url,refreshtime,groups,setButtonDisabled]);





  const createLinkedCalendar = async (event) => {
    const parameters = {
      name,
      url,
      refreshtime,
    }
    axios
      .post(
        postLinkedCalendar(),
        {
          parameters,
          groups,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Lien créé");
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        //setLoading(false);
      });
  };

  const updateLinkedCalendar = async (event) => {
    const parameters = {
      ...currentCalendar.parameters,
      name,
      url,
      refreshtime,
    }
    axios
      .put(
        putLinkedCalendar(currentCalendar.id),
        {
          parameters,
          groups,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Lien modifié");
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        // setLoading(false);
      });
  };

  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={6} md={7} lg={7}>
            <div>
              <TextInput
                inputTitle={linkedcalendartext.name}
                textInput={name}
                handleTextInputChange={handleNameChange}
                disabled={!mbm_geb_control_schedules}
              />
            </div>
            <div>
              <TextInput
                inputTitle={linkedcalendartext.url}
                textInput={url}
                handleTextInputChange={handleUrlChange}
                disabled={!mbm_geb_control_schedules}
              />
            </div>
            <div>
              <IntInput
                inputTitle={linkedcalendartext.refreshtime}
                intInput={refreshtime}
                handleIntInputChange={handleRefreshtimeChange}
                disabled={!mbm_geb_control_schedules}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={6} md={5} lg={5}>
            <div
              className={classes.treeVisible}
            >
              <TreeLabel>Choix du périmètre</TreeLabel>
              <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                <EmbeddedEntitesTree
                  selectedIds={setGroups}
                  userSelectedIds={groups}
                  disabled={!mbm_geb_control_schedules}
                />
              </ImageList>
            </div>
          </GridItem>
        </GridContainer>
      </form>
      {mbm_geb_control_schedules ?
        <Button
          disabled={buttonDisabled}
          className={
            buttonDisabled
              ? classes.submitButtonDisabled
              : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button> : <></>
      }
    </>
  );
}

export default LinkedCalendarDialog;
